/** Border width, style, and divider dimension tokens */
export const borderWidth = {
  none: 0,
  hairline: 1,
  sm: 2,
  md: 3,
} as const;

export const borderStyle = {
  solid: "solid",
  dashed: "dashed",
  dotted: "dotted",
} as const;

export const divider = {
  width: borderWidth.hairline,
  style: borderStyle.solid,
} as const;

export type TBorderWidth = typeof borderWidth;
export type TBorderStyle = typeof borderStyle;
export type TDivider = typeof divider;
